import { WelcomeImages } from "../WelcomeImages";

export class MockWelcomeImages implements WelcomeImages {
  public computer = { background: "", mosaic: "" };
  public phone = { background: "", mosaic: "" };
  public tv = { background: "", mosaic: "" };
}
